"use client";

import React from 'react';
import Image from 'next/image';
import { useRouter } from 'next/navigation';
// import { useGetAllCategories } from '@/hooks/ApiHooks/productHooks/getAllCategoriesHook';
import { useProductListingStore } from "@/zustand/productListingStore";
import { useNewGetAllCategories } from '@/hooks/ApiHooks/newProductListingHooks/newGetAllCategoriesHook';
import Link from 'next/link';

interface Category {
  id: string;
  name: string;
  slug: string;
  image?: { src: string };
  thumbnail?: string;
}

const ProductCategoriesGrid = () => {
  const router = useRouter();
  const { data: categoryData, isLoading } = useNewGetAllCategories();
  // const { data: categoryData, isLoading } = useGetAllCategories();
  const { setCategoryIdToStore, setSubCategoryIdToStore } = useProductListingStore();

  // Process categories same as web view
  const processedCategories = (Array.isArray(categoryData?.result) ? categoryData?.result : [])
    .filter((category: Category) =>
      category?.name !== "Accessories" &&
      category?.name !== "Metal Products"
    )
    .sort((a: Category, b: Category) => {
      if (a?.name === "All Products") return -1;
      if (b?.name === "All Products") return 1;
      return 0;
    });

  const handleCategoryClick = (category: Category) => {
    // Use the same URL format as web view
    // router.push(`/product-category/${category.slug}`);
    setCategoryIdToStore(Number(category.id));
    setSubCategoryIdToStore(0);
  };

  return (
    <div className="min-h-screen bg-white lg:hidden">
             {/* Header */}
       <div className="bg-PrimaryLightBlue px-mob-20 py-mob-16 flex items-center justify-between">
         {/* Back Arrow */}
         <div 
           onClick={() => router.back()}
           className="w-mob-26 h-mob-26 flex items-center justify-center cursor-pointer"
         >
           <svg 
             width="26" 
             height="26" 
             viewBox="0 0 24 24" 
             fill="none" 
             xmlns="http://www.w3.org/2000/svg"
           >
             <path 
               d="M15 18L9 12L15 6" 
               stroke="#FFD700" 
               strokeWidth="2" 
               strokeLinecap="round" 
               strokeLinejoin="round"
             />
           </svg>
         </div>

         {/* Center Content */}
         <div className="flex items-center">
           <div className="relative w-mob-24 h-mob-24 mr-mob-12 shrink-0">
             <Image
               src="/images/allProductIcon.svg"
               alt="All Products"
               fill
               sizes="24px"
               className="object-contain filter"
             />
           </div>
           <h1 className="text-[#92D2FE] text-mob-16 font-medium uppercase tracking-wider">
             ALL PRODUCTS
           </h1>
         </div>

         {/* Empty div for balance */}
         <div className="w-mob-24 h-mob-24"></div>
       </div>

      {/* Categories Grid */}
      <div className="px-mob-20 py-mob-16">
        {isLoading ? (
          <div className="flex justify-center items-center py-mob-50">
            <p className="text-mob-16 text-[#323232]">Loading categories...</p>
          </div>
        ) : (
          <div className="grid grid-cols-2 gap-mob-16 mt-[5vw]">
            {processedCategories.map((category: Category, index: number) => (
            <div
              key={category.id}
              onClick={() => handleCategoryClick(category)}
              className={`border border-[#E4E4E4] rounded-mob-8 p-mob-16 bg-white cursor-pointer hover:shadow-sm transition-shadow duration-200 ${
                index === processedCategories.length - 1 && processedCategories.length % 2 !== 0 ? 'col-span-2 mx-auto w-[calc(50%-8px)]' : ''
              }`}
            >
            <Link href={`/product-category/${category.slug}`}>
              {/* Category Icon */}
              <div className="flex justify-center mb-mob-12">
                <div className="w-[10vw] h-[10vw]">
                  <Image
                    src={category.thumbnail || "/images/drywall-partition.svg"}
                    alt={category.name}
                    width={50}
                    height={50}
                    className="!static !h-full object-contain"
                  />
                </div>
              </div>

              {/* Category Name */}
              <div className="text-center">
                <h3 className="text-mob-18 text-[#323232] leading-[120%] font-satoshi">
                  {category.name.replace(/&amp;/g, "&")}
                </h3>
              </div>
            </Link>
           </div>
         ))}
       </div>
        )}
     </div>
    </div>
  );
};

export default ProductCategoriesGrid;